import api from '../http-common'

const getCoolFarmOptions = (data?) =>
  api.post('/cool-farm-tool/footprints/get-index-data', data)

const getCoolFarmFootprints = (data?) =>
  api.post('/cool-farm-tool/footprints/index', data)

const getCoolFarmCount = (data?) =>
  api.post('/cool-farm-tool/footprints/count', data)

const planCoolFarm = (id: string) =>
  api.post(`/cool-farm-tool/footprints/${id}/plan`)

const deleteCoolFarm = (id: string) =>
  api.post(`/cool-farm-tool/footprints/${id}/delete`)

const getFarmerList = (data) =>
  api.post('/farmer-groups/cool-farm-tool/list', data)

const getCoolFarmOptionsData = () =>
  api.post('/cool-farm-tool/footprints/get-options-data')

const getCoolFarmFootprint = (id: string) =>
  api.post(`/cool-farm-tool/footprints/${id}/edit`)

const getCoolFarmFarmerGroups = (id: string, data) =>
  api.post(`/cool-farm-tool/footprints/${id}/farmer-groups/index`, data)

const updateCoolFarmFootprint = (id: string, data) =>
  api.post(`/cool-farm-tool/footprints/${id}/update`, data)

const createCoolFarmFootprint = (data?) =>
  api.post('/cool-farm-tool/footprints/store', data)

export const CoolFarmService = {
  getCoolFarmCount,
  getCoolFarmOptions,
  getCoolFarmFootprints,
  planCoolFarm,
  deleteCoolFarm,
  getCoolFarmOptionsData,
  getCoolFarmFootprint,
  getCoolFarmFarmerGroups,
  updateCoolFarmFootprint,
  createCoolFarmFootprint,
  getFarmerList
}